module.exports = __webpack_public_path__ + "img/videologo.69d3b203.png";